import { ViewController } from '@estee/elc-service';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { RouterStore } from '@estee/elc-router';

interface IRedirectViewController {
    configRepository: ConfigRepository;
    routerStore: RouterStore;
}

export class RedirectViewController extends ViewController {
    private configRepository: ConfigRepository;
    private routerStore: RouterStore;

    constructor({ configRepository, routerStore }: IRedirectViewController) {
        super();
        this.configRepository = configRepository;
        this.routerStore = routerStore;
    }

    public loaded = async () => {
        const { onSuccessRedirectUrl } = this.configRepository;
        this.routerStore.changeLocation(onSuccessRedirectUrl);
    };
}
